import { useEffect, useRef, useState, type MutableRefObject } from 'react';

/**
 * 요소의 현재 폭(px) — 레이아웃이 바뀔 때마다 갱신된다(ResizeObserver).
 * 첫 렌더와 측정 불가 환경(jsdom)에서는 null — 호출부가 "아직 모름"을 값으로 받는다.
 */
export function useElementWidth<T extends HTMLElement>(): [MutableRefObject<T | null>, number | null] {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState<number | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const measure = () => setWidth(el.getBoundingClientRect().width);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [ref, width];
}
